import { useContext, useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Api from "../api/Api";
import axios from "axios";
import Page from "../layout/Page";
import { AccountContext } from "../Account/AccountContext";
import Form from "../controls/Form";
import Input from "../controls/Input";
import Select from "../controls/Select";
import Checkbox from "../controls/Checkbox";
import Textarea from "../controls/Textarea";
import SegmentModal from "./SegmentModal";
import FileInput from "../controls/FileInput";
import Confirm from "../layout/Confirm";
import ConfirmText from "../layout/ConfirmText";

export default function Card({ edit = false }) {

	const { account } = useContext(AccountContext);
	const { id, type } = useParams();
	const form = useRef();
	const segmentModal = useRef();
	const [card, setCard] = useState(null);
	const [can, setCan] = useState({});
	const [departments, setDepartments] = useState(null);
	const [segments, setSegments] = useState(null);
	const [documents, setDocuments] = useState(null);
	const [files, setFiles] = useState([1]);

	useEffect(() => {
		if (type)
			Api.put('cards/createcard', { Id: type }, loadData);
		else if (edit)
			Api.put('cards/editcard', { Id: id }, loadData);
		else
			Api.put('cards/getcard', { Id: id }, loadData);
	}, []);

	const loadData = response => {
		setCard(response.data.card);
		setCan(response.data.can || {});
		setDepartments(response.data.departments);
		setSegments(response.data.segments);
		setDocuments(response.data.documents);
		setFiles([1]);
	}

	const getAresData = () => {
		let idNumber = form.current.state.IdNumber;
		if (!/^([0-9]{8})$/.test(idNumber)) {
			form.current.addError("IdNumber", 'IČO musí mít přesně 8 číslic');
			return;
		}
		Api.put("cards/getares", { idnumber: idNumber }, (response => {
			if (response.data.ares.ico)
				form.current.setValues({
					Name: response.data.ares.obchodniJmeno,
					Address: response.data.ares.sidlo.textovaAdresa,
				});
			else
				form.current.addError("IdNumber", 'ARES: ' + response.data.ares.popis, 'error');
		}));
	}

	const fileChanged = (i, value) => {
		let fs = [...files];
		if (value)
			fs.push(fs[fs.length - 1] + 1);
		else {
			let x = fs.indexOf(i);
			fs.splice(x, 1);
		}
		setFiles(fs);
	}

	const fileDeleted = (i) => {
		let fs = [];
		for (let x in documents)
			if (documents[x].id != i)
				fs.push(documents[x]);
		setDocuments(fs);
	}

	const cardTypes = {
		1: t.cardTypeVendor,
		2: t.cardTypeCustomer,
		3: t.cardTypeEmployee,
	}

	const states = {
		1: t.cardStateEditing,
		2: t.cardStateSent,
		3: t.cardStateRejected,
		11: t.cardStateManagerApproved,
		21: t.cardStateComplianceApproved,
		22: t.cardStateQrviApproved,
		31: t.cardStateFinancialControllingApproved,
		32: t.cardStateFinancialDirecorApproved,
	}

	const requests = {
		2: t.commonInactive,
		11: t.cardRequestAdd,
		12: t.cardRequestEdit,
		13: t.cardRequestDeactivate,
		14: t.cardRequestActivate,
	}

	const back = card?.state == 1 || card?.state == 2 ? "/cards" : (edit && !type) ? "/requests/" + card?.id : "/requests";

	const onSetState = (state) => {
		if (state == 3)
			ConfirmText({ text: t.cardSetRejectReason }, (res) => Api.put("cards/addstate", { Id: card.id + '', state: 3, Comment: res }, null, back));
		else
			Confirm(() => Api.put("cards/addstate", { Id: card.id + '', state: state, Comment: null }, null, back));
	}

	const onCreateRequest = (state) => {
		if (state == 13 || state == 14)
			ConfirmText({ text: state == 13 ? t.cardSetDeactivateReason : t.cardSetActivateReason }, (res) => Api.put("cards/createrequest", { Id: card.id + '', type: card.type, DepartmentID: card.departmentID, state: state, Comment: res }, null, null, true));
		else
			Confirm(() => Api.put("cards/createrequest", { Id: card.id + '', type: card.type, DepartmentID: card.departmentID, state: state }, null, null, true));
	}

	let actions = [];
	if (can.edit) actions.push(<Link className="btn btn-sm btn-primary ms-2" to={"/requests/" + id + "/edit"}><i className="fa-solid fa-edit"></i> {t.commonEdit}</Link>);
	if (can.delete) actions.push(<span className="btn btn-sm btn-dark ms-2" onClick={() => onSetState(4)}><i className="fa-solid fa-trash"></i> {t.commonDelete}</span>);
	if (can.requestEdit) actions.push(<span className="btn btn-sm btn-warning ms-2" onClick={() => onCreateRequest(can.requestEdit)}>{t.cardRequestEdit}</span>);
	if (can.requestDeactivate) actions.push(<span className="btn btn-sm btn-warning" onClick={() => onCreateRequest(can.requestDeactivate)}>{t.cardRequestDeactivate}</span>);
	if (can.requestActivate) actions.push(<span className="btn btn-sm btn-warning" onClick={() => onCreateRequest(can.requestActivate)}>{t.cardRequestActivate}</span>);
	if (can.showEditor) actions.push(can.showEditor);
	if (can.nextState) {
		actions.push(<span className="btn btn-sm btn-warning ms-2" onClick={() => onSetState(can.nextState)}>{states[card.lastState]} <i className="fa-solid fa-play"></i> {states[can.nextState]}</span>);
		if (can.nextState != 2)
			actions.push(<span className="btn btn-sm btn-danger" onClick={() => onSetState(3)}>{states[3]}</span>);
	}

	return (
		<Page title={card ? cardTypes[card.type] + (requests[card.state] ? ' - ' + requests[card.state] : '') + (card.state != 1 && card.state != 2 && states[card.lastState] ? ' - ' + states[card.lastState] : '') + ' - ' + t.formatDatetime(card.lastCreated) : ''} back={back} submitForm={card?.lastState == 1 && edit ? () => form : null} actions={actions}>
			{card && card.lastState == 1 && edit
				? <><Form action={type ? "cards/createrequest" : "cards/savecard"} redirectOnSuccess={"/requests/" + id} hasFiles ref={form}>
					{type ? <>
						<Input name="state" type="hidden" value="11" />
						<Input name="type" type="hidden" value={type} />
					</> : <Input name="Id" type="hidden" value={id} />}
					<div className="card bg-white">
						<div className="card-body">
							<div className="row gx-1 mb-2">
								<div className="col-lg-3">
									<Input name="IdNumber" label={t.cardIdNumber} type="text" value={card.idNumber}>
										<span className="btn btn-primary d-flex align-items-center" onClick={getAresData}><i className="fa-solid fa-magnifying-glass"></i></span>
									</Input>
								</div>
								<div className="col-lg-3">
									<Input name="VatNumber" label={t.cardVatNumber} type="text" value={card.vatNumber} />
								</div>
								<div className="col-lg-6">
									<Select name="DepartmentID" label={t.cardDepartment} value={card.departmentID} options={departments.map(d => [d.id, d.name])} required />
								</div>
								<div className="col-lg-6">
									<Input name="Name" label={t.cardName} type="text" value={card.name} />
								</div>
								<div className="col-lg-6">
									<Input name="Address" label={t.cardAddress} type="text" value={card.address} />
								</div>
							</div>
							<div className="row gx-1 mb-2">
								<div className="col-lg-4">
									<Input name="BankNumber" label={t.cardBankNumber} type="text" value={card.bankNumber} />
								</div>
								<div className="col-lg-2">
									<Input name="BankCode" label={t.cardBankCode} type="text" value={card.bankCode} />
								</div>
								<div className="col-lg-6">
									<Input name="BankName" label={t.cardBankName} type="text" value={card.bankName} />
								</div>
								<div className="col-lg-6">
									<Input name="SwiftCode" label={t.cardSwiftCode} type="text" value={card.swiftCode} />
								</div>
								<div className="col-lg-4"></div>
								<div className="col-lg-2">
									<Input name="DueDays" label={t.cardDueDays} type="number" value={card.dueDays} />
								</div>
							</div>
							<div className="row gx-1 mb-2">
								<div className="col-lg-6">
									<Input name="Subsegment" label={t.cardSubsegment} type="text" value={card.subsegment} readOnly>
										<span className="btn btn-primary d-flex align-items-center" onClick={() => segmentModal.current.show()}><i className="fa-solid fa-list"></i></span>
									</Input>
								</div>
								<div className="col-lg-3 align-self-center ps-3">
									<Checkbox name="Compliance" label={t.cardCompliance} value={card.compliance || false} readOnly />
								</div>
								<div className="col-lg-3 align-self-center ps-3">
									<Checkbox name="Qrvi" label={t.cardQrvi} value={card.qrvi || false} readOnly />
								</div>
							</div>
							<div className="row gx-1 mb-2">
								<div className="col-lg">
									<label className="form-label">{t.cardAttachments}</label>
									{documents.map((d, i) => <FileInput key={"fo" + d.id} name={"File" + d.id} document={d} onChange={() => fileDeleted(d.id)}></FileInput>)}
									{files.map(i => <FileInput key={"fn" + i} name={"FileNew" + i} onChange={(e) => fileChanged(i, e)}></FileInput>)}
								</div>
							</div>
							<div className="row gx-1 mb-2">
								<div className="col-lg-12">
									<Textarea name="Comment" label={t.cardComment} value={card.lastComment} />
								</div>
							</div>
						</div>
					</div>
				</Form>
					<SegmentModal segments={segments} onSelected={val => form.current.setValues(val)} ref={segmentModal} />
				</>
				: card ? <div className="card bg-white">
					<div className="card-body">
						<div className="row gx-1 mb-2">
							<p className="fw-bold mb-2">{card.name}</p>
							<p>{card.address}</p>
							<div className="col-lg-3">
								<small className="text-muted">{t.cardIdNumber}</small> {card.idNumber}
							</div>
							<div className="col-lg-3">
								<small className="text-muted">{t.cardVatNumber}</small> {card.vatNumber}
							</div>
							<div className="col-lg-3 offset-lg-3">
								<small className="text-muted">{t.cardDepartment}</small> {card.department}
							</div>
							<p className="mt-4">
								{card.bankName}
							</p>
							<div className="col-lg-3">
								<small className="text-muted">{t.cardBankNumber}</small> {card.bankNumber}
							</div>
							<div className="col-lg-3">
								<small className="text-muted">{t.cardBankCode}</small> {card.bankCode}
							</div>
							<div className="col-lg-3">
								<small className="text-muted">{t.cardSwiftCode}</small> {card.swiftCode}
							</div>
							<div className="col-lg-3">
								<small className="text-muted">{t.cardDueDays}</small> {card.dueDays}
							</div>
							<p className="mt-4">
								{card.subsegment}
							</p>
							<div className="col-lg-3">
								<small className="text-muted">{t.cardCompliance}</small> <i className={card.compliance ? "fa-regular fa-square-check" : "fa-regular fa-square"}></i>
							</div>
							<div className="col-lg-3">
								<small className="text-muted">{t.cardQrvi}</small> <i className={card.qrvi ? "fa-regular fa-square-check" : "fa-regular fa-square"}></i>
							</div>
							{documents.length ? <ul className="mt-4 mb-0 list-unstyled">
								{documents.map(d => <li key={d.id} className="pointer" onClick={() => Api.download('download', { Id: d.id + '' })}><i className="fa-solid fa-download"></i> {d.name} ({t.fileSize(d.size)})</li>)}
							</ul> : null}
							<p className="mt-3">{card.lastComment}</p>
						</div>
					</div>
				</div>
					: null}
		</Page>
	);
}